import type { HelpArticle } from '../types';
import mapEhrText from './map-ehr-text';
import ehrSupplementsTubeFeeds from './ehr-supplements-tube-feeds';
import gettingAround from './getting-around';
import yourDashboard from './your-dashboard';
import findingAResident from './finding-a-resident';
import settingsAndPreferences from './settings-and-preferences';
import switchingFacility from './switching-facility';
import runningAReport from './running-a-report';
import favoritesAndPrintQueue from './favorites-and-print-queue';
import admitResident from './admit-resident';
import changeDietOrder from './change-diet-order';
import allergiesLikesDislikes from './allergies-likes-dislikes';
import mealPatterns from './meal-patterns';
import enteringWeights from './entering-weights';
import dischargeReadmit from './discharge-readmit';
import selectiveTouch from './selective-touch';
import trayTickets from './tray-tickets';
import trayLineSetup from './tray-line-setup';
import menuCycles from './menu-cycles';
import readingAMenuCycle from './reading-a-menu-cycle';
import changingMenuItems from './changing-menu-items';
import dietAndConsistencyRules from './diet-and-consistency-rules';
import syncedRowsAndPushTo from './synced-rows-and-push-to';
import holidayAndOneTimeMenus from './holiday-and-one-time-menus';
import menuSwapAndRequests from './menu-swap-and-requests';
import autoItemMods from './auto-item-mods';
import importingAMenu from './importing-a-menu';
import menuAnalysis from './menu-analysis';
import askingForAMenuChange from './asking-for-a-menu-change';
import askingToSwapTwoMeals from './asking-to-swap-two-meals';
import usingAnalysis from './using-analysis';
import ehrConnection from './ehr-connection';
import firstDay from './first-day';
import glossary from './glossary';
import adjustments from './adjustments';
import printersAndPrinting from './printers-and-printing';
import nutritionCompliance from './nutrition-compliance';
import nutritionAssessments from './nutrition-assessments';
import planOfCare from './plan-of-care';
import phonesAndTablets from './phones-and-tablets';
import guests from './guests';
import itemsAndRecipes from './items-and-recipes';
import specialEvents from './special-events';
import rolesAndAccess from './roles-and-access';
import facilitySetup from './facility-setup';
import gettingStarted from './getting-started';
import ehrPage from './ehr-page';
import ehrFrequenciesActionPlans from './ehr-frequencies-action-plans';
import ehrHeldDietOrders from './ehr-held-diet-orders';
import autoTrayLineSetup from './auto-tray-line-setup';
import allergyProtectionCheck from './allergy-protection-check';
import printingSetup from './printing-setup';
import selectiveTouchSetup from './selective-touch-setup';
import nutritionalAnalysisAndValidation from './nutritional-analysis-and-validation';
import census from './census';
import credits from './credits';
import intakeStudies from './intake-studies';
import dietConfiguration from './diet-configuration';
import tables from './tables';
import bulkOrder from './bulk-order';
import forecasting from './forecasting';
import diningRoomsAndEmployees from './dining-rooms-and-employees';
import workflows from './workflows';
import surveys from './surveys';
import menuAndNourishmentCost from './menu-and-nourishment-cost';
import corporateDashboard from './corporate-dashboard';

/**
 * Every help article. Each data file is written by the recorder (tutorials/record.cjs) from its script
 * in tutorials/articles/; add the import here when a new one is recorded.
 */
export const HELP_ARTICLES: HelpArticle[] = [
  mapEhrText,
  ehrSupplementsTubeFeeds,
  ehrConnection,
  ehrPage, ehrFrequenciesActionPlans, ehrHeldDietOrders,
  firstDay,
  gettingAround,
  yourDashboard,
  findingAResident,
  settingsAndPreferences,
  switchingFacility,
  runningAReport,
  favoritesAndPrintQueue,
  phonesAndTablets,
  admitResident, changeDietOrder, allergiesLikesDislikes, adjustments, mealPatterns, enteringWeights, dischargeReadmit, guests,
  selectiveTouch, trayTickets, trayLineSetup,
  menuCycles, readingAMenuCycle, changingMenuItems, dietAndConsistencyRules, syncedRowsAndPushTo, holidayAndOneTimeMenus,
  menuSwapAndRequests, autoItemMods, importingAMenu, menuAnalysis, askingForAMenuChange, askingToSwapTwoMeals,
  specialEvents, itemsAndRecipes,
  gettingStarted, facilitySetup, rolesAndAccess,
  usingAnalysis,
  nutritionCompliance, nutritionAssessments, planOfCare,
  glossary,
  autoTrayLineSetup, allergyProtectionCheck, printingSetup, selectiveTouchSetup,
  census, credits, intakeStudies, nutritionalAnalysisAndValidation, dietConfiguration, tables,
  bulkOrder, forecasting, diningRoomsAndEmployees, workflows, surveys, menuAndNourishmentCost, corporateDashboard,
  printersAndPrinting,
];

/**
 * Articles about pages only PSI staff can open: listed, linked and opened for PSI staff only. Importing
 * a vendor's menu is New Menu's, which customers no longer have (Jeff, 2026-11-04).
 */
export const PSI_ONLY_ARTICLES: ReadonlySet<string> = new Set(['importing-a-menu']);

/** Whether this user is shown the article (PSI_ONLY_ARTICLES). */
export function articleShown(slug: string, isPsi: boolean): boolean {
  return isPsi || !PSI_ONLY_ARTICLES.has(slug);
}

export function findArticle(slug: string | undefined): HelpArticle | undefined {
  return HELP_ARTICLES.find((a) => a.slug === slug);
}
